export const VEHICLES_BULK_TEMPLATE = 'https://storage.googleapis.com/fleet-it-app-bucket/static/templates/FleetIT_Bulk_Upload_Template.csv';
export const VEHICLES_BULK_TEMPLATE_NEW = 'https://storage.googleapis.com/fleet-it-app-bucket/static/templates/FleetIT_Bulk_Upload_Template_new.csv';
